import { configs } from "configs/config";
import { axios } from "utils/axios";
import { authenJWT } from "./auth";

export const postBookOCR = async (body: FormData) => {
  const loginToken = await authenJWT();
  return axios.post(`${configs.apiUrl}/ocr/VehicleRegistrationBookOCR`, body, {
    headers: {
      Authorization: `Bearer ${loginToken?.data?.Token || ""}`,
    },
  });
};
